import { createRoute, Navigate } from '@tanstack/react-router';
import LoadingScreen from 'components/LoadingScreen';
import MainLayout from 'layouts/dashboard/MainLayout';
import { rootRoute } from 'routes/rootRoute';
import { canAccessAdminPages, WithEnsure } from 'routes/routeUtils';

export const adminParentRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: () => WithEnsure(canAccessAdminPages, <MainLayout />),
  path: '/admin',
  pendingComponent: LoadingScreen,
});

export const adminIndexRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/',
  component: () => <Navigate to="/admin/home" />,
});
